import { errorLogger } from '@ajaibid/utils';
import fetcher from '@helpers/fetcher';

function getUrl(code) {
  return `v1/stock/detail/${code}/price/compare/`;
}

/**
 * Build an async callback for react-query based on given url
 * @param {string} url
 */
function callbackFetch(url) {
  return async () => {
    try {
      /** @type {{ data: any }} */
      const res = await fetcher.get(url);
      return res.data;
    } catch (err) {
      errorLogger('ERROR_API', err.message);
      throw err;
    }
  };
}

/**
 * Factory returning query key + fetch callback for useQuery
 * @param {string} stockCode
 */
export default function fetch(stockCode) {
  const url = getUrl(stockCode);
  const cb = callbackFetch(url);
  const key = [url];
  return { cb, key };
}
